import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';

const news = [
  {
    date: '2026.08',
    tag: '联盟赋能',
    title: '深度参与全国OPC社区网络建设',
    description:
      '作为冯全普·县域AI+OPC联盟核心成员，协同石家庄、廊坊、张家口、雄安新区、太原、临沂、唐山等地推进OPC社区运营。',
    highlight: true,
  },
  {
    date: '2026.07',
    tag: '战略发布',
    title: '启动"山西故事文化出海计划"',
    description:
      '以山西117个县域文化资源为内容源，以AI数字光影内容为载体，携手图兰朵等海外合作伙伴，布局美国、东南亚等海外市场，推动中国文化数字化出海。',
    highlight: false,
  },
  {
    date: '2026.06',
    tag: '项目里程碑',
    title: '山西非遗文化数字资产库1.0正式建成',
    description:
      '历时数月系统化整理与数字化研发，覆盖山西全境117个县域的非遗文化资源已完成数字化采集、归档与云端入库，标志着我司在文化数字资产底层建设上取得里程碑式突破。',
  },
  {
    date: '2026.06',
    tag: '战略合作',
    title: '携手舌尖味道达成全国独家运营战略合作',
    description:
      '晋铧叙梦与舌尖味道品牌正式签署全国独家运营战略合作协议，三大IP主题直播间将陆续上线，标志着公司在品牌文化赋能与流量电商运营领域迈出关键一步。',
  },
];

export default function EnterpriseNews() {
  return (
    <section className="relative w-full bg-background-900 py-20 md:py-28 overflow-hidden">
      <div className="w-full px-4 md:px-8 lg:px-12 relative z-10">
        <div className="max-w-screen-2xl mx-auto">
          <ScrollReveal>
            <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-16">
              <div>
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/10 border border-accent-500/20 mb-6">
                  <span className="w-1 h-1 rounded-full bg-accent-500 animate-pulse"></span>
                  <span className="text-accent-300 text-xs font-medium tracking-wider whitespace-nowrap">
                    企业动态
                  </span>
                </div>
                <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50">
                  最新动态
                </h2>
              </div>
              <Link
                to="/news"
                className="group inline-flex items-center gap-2 text-primary-500 text-sm font-medium hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看全部动态
                <span className="w-4 h-4 flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {news.map((item) => (
              <ScrollReveal key={item.title}>
                <div
                  className={`news-card group relative rounded-2xl border p-7 md:p-8 transition-all duration-500 ${
                    item.highlight
                      ? 'bg-accent-500/5 border-accent-500/20 hover:border-accent-500/40'
                      : 'bg-background-800/40 border-primary-500/10 hover:border-primary-500/25'
                  }`}
                >
                  {/* Hover glow effect */}
                  <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
                    style={{
                      background: item.highlight
                        ? 'radial-gradient(circle at 80% 20%, rgba(180,60,40,0.08) 0%, transparent 70%)'
                        : 'radial-gradient(circle at 80% 20%, rgba(200,160,80,0.04) 0%, transparent 70%)',
                    }}
                  ></div>

                  <div className="flex items-center justify-between mb-4">
                    <span className="text-secondary-500 text-xs font-mono">{item.date}</span>
                    <span
                      className={`px-3 py-1 rounded-full text-xs font-medium whitespace-nowrap transition-all duration-300 ${
                        item.highlight
                          ? 'bg-accent-500/20 text-accent-300 border border-accent-500/30 group-hover:bg-accent-500/25'
                          : 'bg-secondary-500/10 text-secondary-400 border border-secondary-500/20 group-hover:bg-secondary-500/15'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>

                  {item.highlight && (
                    <div className="absolute top-0 right-0 w-24 h-24 bg-accent-500/[0.03] rounded-bl-full pointer-events-none group-hover:bg-accent-500/[0.06] transition-all duration-500"></div>
                  )}

                  <h3
                    className={`relative z-10 font-heading text-lg font-semibold mb-3 transition-colors duration-300 ${
                      item.highlight ? 'text-accent-300' : 'text-foreground-50 group-hover:text-primary-400'
                    }`}
                  >
                    {item.title}
                  </h3>
                  <p className="relative z-10 text-secondary-400 text-sm leading-relaxed">
                    {item.description}
                  </p>

                  <Link
                    to="/news"
                    className="group/link relative z-10 inline-flex items-center gap-1.5 mt-5 text-xs text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    阅读详情
                    <span className="w-3 h-3 flex items-center justify-center transition-all duration-300 group-hover/link:translate-x-0.5">
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </Link>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
